// 固件列表查询
const QueryForm = {
    labelCol: { style: { width: '100px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        {
            // name:'app id',
            key:'app_id',
            type:'input',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按app id查询',
        },
        {
            // name:'名称',
            key:'app_name',
            type:'input',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按名称查询',
        },
        {
            // name:'状态',
            key:'status',
            type:'select',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按状态查询',
            options:[
                {
                    label:'启用',
                    value:0,
                },
                {
                    label:'禁用',
                    value:1,
                },
            ]
        },
    ]
}

QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
    if(item.key == 'status'){
        QueryForm.formData[item.key] = null
    }
})

export {
    QueryForm
}